export default __webpack_public_path__ + "static/media/2.81c89617.mp3";